var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c(
        "div",
        { staticClass: "text-right mb-2" },
        [
          _vm._v(" " + _vm._s(_vm.reloadTime) + " "),
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "small" },
              on: {
                click: function ($event) {
                  _vm.clearTipDialogVisible = true
                },
              },
            },
            [_vm._v("清除跨日資料")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fixed-list-item" },
        [
          _c("eva-icon", {
            attrs: { fill: "#000", name: "refresh-outline" },
            on: { click: _vm.reload },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "row", staticStyle: { cursor: "default" } }, [
        _c(
          "div",
          { staticClass: "col-md-2" },
          [
            _c(
              "draggable",
              {
                staticClass: "list-group unselect-block",
                attrs: {
                  list: _vm.roomList.WaitArranges,
                  sort: false,
                  group: "people",
                },
                on: {
                  add: function ($event) {
                    return _vm.onAdd($event, null)
                  },
                },
              },
              _vm._l(_vm.roomList.WaitArranges, function (person, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "p-item" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content:
                            person.PreAssignRoom && person.PreAssignRoom.Name
                              ? person.PreAssignRoom.Name
                              : null,
                          placement: "top-start",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "i-wrap" },
                          [
                            _vm._v(" " + _vm._s(index + 1) + "- "),
                            person.PreAssignRoom && person.PreAssignRoom.Name
                              ? [_vm._v(_vm._s(person.PreAssignRoom.Name))]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: person.Name,
                          placement: "top-start",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "name-link",
                            class: {
                              female: person.Sex && person.Sex === "女",
                              male: person.Sex && person.Sex === "男",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showDetailModal(person)
                              },
                            },
                          },
                          [_vm._v(_vm._s(person.Name))]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ],
          1
        ),
        _c("div", { staticClass: "col-md-10" }, [
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.roomList.Rooms, function (room, index) {
              return _c(
                "div",
                { key: index, staticClass: "col-md-4 col-lg-3" },
                [
                  _c(
                    "div",
                    { staticClass: "room-info" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: room.Name,
                            placement: "top-start",
                          },
                        },
                        [
                          _c("span", { staticClass: "room-name" }, [
                            _vm._v(_vm._s(room.Name)),
                          ]),
                        ]
                      ),
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#5380f7",
                          "inactive-color": "#CCC",
                          disabled: room.Arranged,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.enableChange($event, room)
                          },
                        },
                        model: {
                          value: room.IsEnabled,
                          callback: function ($$v) {
                            _vm.$set(room, "IsEnabled", $$v)
                          },
                          expression: "room.IsEnabled",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "room-block" },
                    [
                      room.IsEnabled
                        ? _c(
                            "draggable",
                            {
                              staticClass: "list-group",
                              attrs: {
                                list: room.Arrange,
                                group: {
                                  name: "people",
                                  pull:
                                    room.Arrange &&
                                    room.Arrange.length > 0 &&
                                    room.Arrange[0].StartTime,
                                  put: !room.Arranged,
                                },
                              },
                              on: {
                                add: function ($event) {
                                  return _vm.onAdd($event, room.Guid)
                                },
                              },
                            },
                            _vm._l(room.Arrange, function (person, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "p-item" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: person.Name,
                                        placement: "top-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "name-link",
                                          class: {
                                            female: person.Sex === "女",
                                            male: person.Sex === "男",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showDetailModal(person)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(person.Name))]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "edit-block" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(person.StageName) + " "
                                      ),
                                      person.StartTime
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("momentTime")(
                                                  person.StartTime
                                                )
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      !person.StartTime
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                                round: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.start(
                                                    person.Guid,
                                                    person.StageGuid
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("開始")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" / "),
                                      person.StartTime
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                                round: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.end(
                                                    person.Guid,
                                                    person.StageGuid
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("結束")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "0.85em",
                                            "margin-top": "5px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " 預計 " +
                                              _vm._s(
                                                _vm._f("momentTime")(
                                                  person.ExpectEndTime
                                                )
                                              ) +
                                              " 結束 "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      !room.IsEnabled
                        ? _c(
                            "div",
                            {
                              staticClass: "text-center",
                              staticStyle: {
                                padding: "3px 0px",
                                "background-color": "#db6a6a",
                                display: "block",
                                color: "#fff",
                                width: "98px",
                                margin: "16px auto",
                                "border-radius": "25px",
                                "font-size": "0.8em",
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "15",
                                    fill: "#FFF",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 512 512",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" 未啟用 "),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c("a", [
                      _c(
                        "span",
                        [
                          _c("eva-icon", {
                            attrs: { name: "person-outline", fill: "#FFF" },
                          }),
                          _vm._v(" 履歷 "),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _c("perfect-scrollbar", { staticClass: "page" }, [
                            _c(
                              "section",
                              { staticClass: "page-inner" },
                              [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "div",
                                    { staticClass: "item text-center" },
                                    [_vm._v("履歷")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "item text-right" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-primary btn-sm",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$common.downloadResumePDF(
                                                _vm.resumeDetail.ResumeType,
                                                _vm.resumeDetail.ResumeId
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 下載 PDF ")]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm.resumeDetail.ResumeType === "IDL"
                                  ? _c("IdlResume", {
                                      attrs: {
                                        ResumeId: _vm.resumeDetail.ResumeId,
                                        ResumeType: "IDL",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.resumeDetail.ResumeType === "DL"
                                  ? _c("DlResume", {
                                      attrs: {
                                        ResumeId: _vm.resumeDetail.ResumeId,
                                        ResumeType: "DL",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "清除跨日資料",
            visible: _vm.clearTipDialogVisible,
            width: "480px",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.clearTipDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("span", [_vm._v("是否確定刪除昨日以前的面談室安排?")]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.clearTipDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.clearAssignRoom()
                    },
                  },
                },
                [_vm._v("確定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }